export default "<p>\n  check-in-out works!\n</p>\n";